<div class="banking-info-container">
  <mat-form-field class="search-box" appearance="outline">
    <mat-label>Employee ID</mat-label>
    <input matInput [(ngModel)]="employeeId" />
  </mat-form-field>
  <button mat-raised-button color="primary" (click)="findBankingInfo(employeeId)">Search</button>

  <div *ngIf="bankingInfo as bankingInfoArray" class="banking-info-details">
    <h2>Employee Banking Information</h2>
    <mat-tab-group>
      <mat-tab *ngFor="let bankingInfo of bankingInfoArray" [label]="bankingInfo.country">
        <mat-list *ngIf="BANKING_INFO_LABEL_MAPPING[bankingInfo.country] as mapping">
          <mat-list-item>
            <strong class="label">Employee ID:</strong> {{ bankingInfo.employeeId }}
          </mat-list-item>
          <mat-list-item *ngIf="bankingInfo.employmentStatus">
            <strong class="label">Employment Status:</strong> {{ bankingInfo.employmentStatus }} {{bankingInfo.terminationDate ? '(' + (bankingInfo.terminationDate | date: 'MM/dd/yyyy') + ')' : '' }}
          </mat-list-item>
          <mat-list-item>
            <strong class="label">Account Name:</strong> {{ bankingInfo.accountName }}
          </mat-list-item>
          <mat-list-item>
            <strong class="label">Account Number:</strong> {{ bankingInfo.accountNumber }}
          </mat-list-item>
          <mat-list-item>
            <strong class="label">Account Type:</strong> {{ bankingInfo.accountType }}
          </mat-list-item>
          <mat-list-item *ngIf="mapping['attribute1']">
            <strong class="label">{{mapping['attribute1']}}:</strong> {{ bankingInfo.attribute1 }}
          </mat-list-item>
          <mat-list-item *ngIf="mapping['attribute2']">
            <strong class="label">{{mapping['attribute2']}}:</strong> {{ bankingInfo.attribute2 }}
          </mat-list-item>
          <mat-list-item *ngIf="mapping['attribute3']">
            <strong class="label">{{mapping['attribute3']}}:</strong> {{ bankingInfo.attribute3 }}
          </mat-list-item>
          <mat-list-item *ngIf="mapping['attribute4']">
            <strong class="label">{{mapping['attribute4']}}:</strong> {{ bankingInfo.attribute4 }}
          </mat-list-item>
          <mat-list-item *ngIf="mapping['attribute5']">
            <strong class="label">{{mapping['attribute5']}}:</strong> {{ bankingInfo.attribute5 }}
          </mat-list-item>
          <mat-list-item *ngIf="bankingInfo.address">
            <strong class="label">Address:</strong> {{ bankingInfo.address }}
          </mat-list-item>
          <mat-list-item>
            <strong class="label">Last Updated On:</strong>
            {{ bankingInfo.updatedDatetime | date: 'MM/dd/yyyy - HH:mm:ss' }}
          </mat-list-item>
        </mat-list>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
